import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, switchMap } from 'rxjs';
import { errMessage } from '@ui';
import { ContactsActivityLogActions } from '../state/contacts-activity-log/contacts-activity-log.actions';
import { ContactsActivityLogService } from '../../services/contacts-activity-log.service';
import { SharedActions } from '../state/shared/shared.actions';

export const startLoadingContactsActivityLog$ = createEffect(
  (actions$ = inject(Actions)) =>
    actions$.pipe(
      ofType(ContactsActivityLogActions.startLoadingContactsActivityLog),
      exhaustMap(({ filters }) => [
        ContactsActivityLogActions.setIsLoading({ isLoading: true }),
        ContactsActivityLogActions.loadContactsActivityLog({ filters }),
      ]),
    ),
  { functional: true },
);

export const loadContactsActivityLog$ = createEffect(
  (actions$ = inject(Actions), service = inject(ContactsActivityLogService)) =>
    actions$.pipe(
      ofType(ContactsActivityLogActions.loadContactsActivityLog),
      switchMap(({ filters }) =>
        service.getAll(filters).pipe(
          switchMap((items) => [
            ContactsActivityLogActions.loadContactsActivityLogSuccess({ items }),
            ContactsActivityLogActions.setIsLoading({ isLoading: false }),
          ]),
          catchError((response) => [
            ContactsActivityLogActions.loadContactsActivityLogFail(),
            ContactsActivityLogActions.setIsLoading({ isLoading: false }),
            SharedActions.showMessage({ error: errMessage(response) }),
          ]),
        ),
      ),
    ),
  { functional: true },
);

export const loadContactsActivityLogById$ = createEffect(
  (actions$ = inject(Actions), service = inject(ContactsActivityLogService)) =>
    actions$.pipe(
      ofType(ContactsActivityLogActions.loadContactsActivityLogById),
      switchMap(({ id }) =>
        service.getById(id).pipe(
          switchMap((item) => [
            ContactsActivityLogActions.loadContactsActivityLogByIdSuccess({ item }),
          ]),
          catchError((response) => [
            ContactsActivityLogActions.loadContactsActivityLogByIdFail(),
            SharedActions.showMessage({ error: errMessage(response) }),
          ]),
        ),
      ),
    ),
  { functional: true },
);
